import { CartItem } from "../../domain";
import { LocalDataSource } from "../core";

type RawCartItem = {
  productId: string;
  attributeId: string;
  count: number;
};

export class CartLocalDataSource extends LocalDataSource {
  private loadRawCartItems(): RawCartItem[] {
    const cartItemsJson = this.getCookie("cart_items");
    if (cartItemsJson === undefined) return [];
    return JSON.parse(cartItemsJson) as RawCartItem[];
  }

  private saveCartItems(cartItems: RawCartItem[]): void {
    this.setCookie("cart_items", JSON.stringify(cartItems), 2);
  }

  public clearCart(): void {
    this.saveCartItems([]);
  }

  public loadCartItems(): CartItem[] {
    return this.loadRawCartItems().map((json: any) =>
      new CartItem().deserialize(json)
    );
  }

  public addToCart(
    productId: string,
    attributeId: string,
    count: number
  ): void {
    const cartItems = this.loadRawCartItems();
    const itemIndex = cartItems.findIndex(
      (item) => item.productId === productId && item.attributeId === attributeId
    );
    if (itemIndex === -1) {
      cartItems.unshift({ productId, attributeId, count });
    } else {
      cartItems[itemIndex].count += count;
    }
    this.saveCartItems(cartItems);
  }

  public removeFromCart(productId: string, attributeId: string): void {
    const cartItems = this.loadRawCartItems();
    const itemIndex = cartItems.findIndex(
      (item) => item.productId === productId && item.attributeId === attributeId
    );
    cartItems.splice(itemIndex, 1);
    this.saveCartItems(cartItems);
  }

  public increaseCount(productId: string, attributeId: string): void {
    const cartItems = this.loadRawCartItems();
    const cartItemIndex = cartItems.findIndex(
      (item) => item.productId === productId && item.attributeId === attributeId
    );
    cartItems[cartItemIndex].count++;
    this.saveCartItems(cartItems);
  }

  public decreaseCount(productId: string, attributeId: string): void {
    const cartItems = this.loadRawCartItems();
    const cartItemIndex = cartItems.findIndex(
      (item) => item.productId === productId && item.attributeId === attributeId
    );
    if (cartItems[cartItemIndex].count > 1) cartItems[cartItemIndex].count--;
    this.saveCartItems(cartItems);
  }
}
